//noScroll
class SwiperEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const swiper = new Swiper(".swiper", {
      effect: 'slide',
      loop: true,
      speed: 2000,
      slidesPerView: 1,
      autoplay: {
        delay: 3000,
      },

      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  }
}
